import React, { Component } from 'react';
import { browserHistory } from 'react-router';
import commonUtil from '../../../../utils/commonUtil';
import serverClientUtil from '../../../../utils/serverClientUtil';

import Entermytable from './Entermytable';
import Login from './Login';
import Tagging from '../../../../components/Tagging';

const applicationRoutes = commonUtil.getApplicationRoutes();

class SideScreen extends Component {
  constructor(props) {
    super(props);
    this.loggedIn = '';
    this.toggleRegister = this.toggleRegister.bind(this);
    this.state = {
      showStore: true,
    };
  }
  toggleRegister() {
    this.setState({ showStore: !this.state.showStore });
  }
  getTaggingData = (data, URL) => {
    const _dataLayer = {};
    const _loginInfo = {};

    _dataLayer.event = 'Login';
    _dataLayer.category = 'Login';
    _loginInfo.url = URL;
    _dataLayer.login = commonUtil.getUserInfo(data);

    return _dataLayer;
  }
  render() {
    this.loggedIn = this.props.user.loaded && this.props.user.data.result && this.props.user.data.result.firstName;
    const eventDetail = this.props && this.props.eventDetail && this.props.eventDetail.data && this.props.eventDetail.data.eventList;
    const eventDetails = this.props && this.props.user && this.props.user.data && this.props.user.data.result && this.props.user.data.result.myEventDetail;
    const { lables } = this.props;
    let hideWarningMessage = false;
    if (eventDetail) {
      hideWarningMessage = eventDetail.length >= 1;
    } else if (eventDetails) {
      hideWarningMessage = eventDetails.length >= 1;
    }
    if (this.loggedIn && this.props && this.props.user && this.props.user.data && this.props.user.data.result && this.props.user.data.result.redirectToChangePassword === 'Yes') {
      const _url = serverClientUtil.getLPFullURL() + '/users/changePassword';

      const _dataLayer = this.getTaggingData(this.props.user.data, _url);
      this.tagging.applyGTM('Login', _dataLayer);

      window.location.href = _url;
    } else if ((this.loggedIn && eventDetails && eventDetails.length > 1) || (this.loggedIn && eventDetail && eventDetail.length > 1)) {
      const _dataLayer = this.getTaggingData(this.props.user.data, applicationRoutes.multipleEvents);
      this.tagging.applyGTM('Login', _dataLayer);

      browserHistory.push({ pathname: applicationRoutes.multipleEvents });
    } else if (this.loggedIn && eventDetails && eventDetails.length === 1) {
      const _url = commonUtil.routeTo(applicationRoutes.giftList, { eventID: eventDetails[0].eventId });
      const _dataLayer = this.getTaggingData(this.props.user.data, _url);
      this.tagging.applyGTM('Login', _dataLayer);

      browserHistory.push(_url);
    } else if (this.loggedIn && eventDetail && eventDetail.length === 1) {
      const _url = commonUtil.routeTo(applicationRoutes.giftList, { eventID: eventDetails[0].eventId });
      const _dataLayer = this.getTaggingData(this.props.user.data, _url);
      this.tagging.applyGTM('Login', _dataLayer);

      browserHistory.push(_url);
    }
    return (
      <React.Fragment>
        <Tagging ref={tagging => this.tagging = tagging} />
        {this.state.showStore || this.loggedIn ? <Entermytable user={this.props.user} hideWarningMessage={hideWarningMessage} toggleRegister={this.toggleRegister} checkUser={this.checkUser} _handleRedirects={this.props._handleRedirects} lables={lables} /> : <Login user={this.props.user} toggleRegister={this.toggleRegister} _handleUserLogin={this.props._handleUserLogin} checkUser={this.checkUser} lables={lables} />}
      </React.Fragment>
    );
  }
}
export default SideScreen;
